"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHttpRequestSettings = void 0;
var _checkoutUtils = require("@ori/checkout-utils");
var _fetching = require("@ori/fetching");
var _types = require("../types");
const getHttpRequestSettings = (data, method = _checkoutUtils.HttpMethod.Get) => {
  const headers = {
    [_fetching.CONTENT_TYPE]: _types.ContentType.Json
  };
  let body;
  if (data) {
    const {
      placement,
      ...finalData
    } = data;
    if (placement !== undefined) {
      headers[_fetching.PLACEMENT] = placement;
    }
    const bodyValue = JSON.stringify(finalData);
    body = bodyValue === '{}' ? undefined : bodyValue;
  }
  return {
    credentials: 'same-origin',
    headers,
    method,
    ...(method === _checkoutUtils.HttpMethod.Post && Boolean(body) && {
      body
    })
  };
};
exports.getHttpRequestSettings = getHttpRequestSettings;
